var IpcDataModel = require("./index.js");

module.exports = {
    soic: {
        horizontalPadCount: 20,
        horizontalLeadToLeadSpanMin: 10000,
        horizontalLeadToLeadSpanMax: 10650,
        padWidthMin: 400,
        padWidthMax: 1270,
        padHeightMin: 330,
        padHeightMax: 510,
        verticalPinPitch: 1270,
        bodyWidthMin: 7400,
        bodyWidthMax: 7600,
        bodyLengthMin: 12600,
        bodyLengthMax: 13000,
        bodyHeightMin: 0,
        bodyHeightMax: 2650,
        bodyOffsetMin: 250,
        bodyOffsetMax: 250,
        thermalPadLength: 4800,
        thermalPadWidth: 8610,
        thermalPadSolderPasteStencilApertureGapX: 0,
        thermalPadSolderPasteStencilApertureGapY: 650,
        thermalPadSolderPasteStencilApertureLength: 3720,
        thermalPadSolderPasteStencilApertureWidth: 3330,
        thermalPadSolderPasteStencilRowCount: 2,
        thermalPadSolderPasteStencilColCount: 1,
        customPadLength: 2052,
        customPadWidth: 602,
        customPadSpan1: 7255
    },

    sot23: {
        horizontalPadCount: 3,
        horizontalLeadToLeadSpanMin: 2300,
        horizontalLeadToLeadSpanMax: 2500,
        padWidthMin: 450,
        padWidthMax: 610,
        padHeightMin: 370,
        padHeightMax: 510,
        verticalPinPitch: 950,
        bodyWidthMin: 1200,
        bodyWidthMax: 1400,
        bodyLengthMin: 2800,
        bodyLengthMax: 3000,
        bodyHeightMin: 0,
        bodyHeightMax: 1100,
        bodyOffsetMin: 100,
        bodyOffsetMax: 100,
        customPadLength: 610,
        customPadWidth: 1180,
        customPadPitch: 2040
    },

    sotfl: {
        horizontalPadCount: 5,
        horizontalLeadToLeadSpanMin: 1500,
        horizontalLeadToLeadSpanMax: 1700,
        padWidthMin: 250,
        padWidthMax: 450,
        padHeightMin: 150,
        padHeightMax: 300,
        verticalPinPitch: 500,
        bodyWidthMin: 1100,
        bodyWidthMax: 1300,
        bodyLengthMin: 1500,
        bodyLengthMax: 1700,
        bodyHeightMin: 0,
        bodyHeightMax: 600,
        customPadLength: 340,
        customPadWidth: 710,
        customPadPitch: 1420
    },

    sot223: {
        horizontalPadCount: 4,
        horizontalLeadToLeadSpanMin: 6700,
        horizontalLeadToLeadSpanMax: 7300,
        padWidthMin: 700,
        padWidthMax: 1100,
        padHeightMin: 600,
        padHeightMax: 800,
        verticalPinPitch: 2300,
        bodyWidthMin: 3300,
        bodyWidthMax: 3700,
        bodyLengthMin: 6300,
        bodyLengthMax: 6700,
        bodyHeightMin: 0,
        bodyHeightMax: 1800,
        bodyOffsetMin: 100,
        bodyOffsetMax: 100,
        oddPadHeightMax: 3100,
        oddPadHeightMin: 2900,
        customPadLength: 890,
        customPadWidth: 1970,
        customPadPitch: 6040,
        customOddPadLength: 3190,
        customOddPadWidth: 1970
    },

    sot143: {
        horizontalPadCount: 4,
        horizontalLeadToLeadSpanMin: 2100,
        horizontalLeadToLeadSpanMax: 2640,
        padWidthMin: 400,
        padWidthMax: 600,
        padHeightMin: 370,
        padHeightMax: 500,
        verticalPinPitch: 1920,
        bodyWidthMin: 1200,
        bodyWidthMax: 1400,
        bodyLengthMin: 2800,
        bodyLengthMax: 3040,
        bodyHeightMin: 0,
        bodyHeightMax: 1140,
        bodyOffsetMin: 130,
        bodyOffsetMax: 130,
        oddPadHeightMax: 890,
        oddPadHeightMin: 760,
        customPadLength: 600,
        customPadWidth: 1300,
        customOddPadLength: 990,
        customOddPadWidth: 1300,
        pinPitch1: 1730,
        customPadPitch : 2050
    },

    toDpak: {
        horizontalPadCount: 4,
        horizontalLeadToLeadSpanMin: 10410,
        horizontalLeadToLeadSpanMax: 10670,
        padWidthMin: 790,
        padWidthMax: 1040,
        padHeightMin: 630,
        padHeightMax: 790,
        verticalPinPitch: 2540,
        bodyWidthMin: 6890,
        bodyWidthMax: 7140,
        bodyLengthMin: 8270,
        bodyLengthMax: 8520,
        bodyHeightMin: 0,
        bodyHeightMax: 2400,
        bodyOffsetMin: 100,
        bodyOffsetMax: 100,
        oddPadHeightMax: 5590,
        oddPadHeightMin: 5590,
        oddPadWidthMax: 6490,
        oddPadWidthMin: 6490,
        extendedEdgeWidth: 1010,
        customPadLength: 890,
        customPadWidth: 1810,
        customPadSpan1: 11390,
        customOddPadLength: 5760,
        customOddPadWidth: 7020
    },

    chip: {
        horizontalPadCount: 2,
        horizontalLeadToLeadSpanMin: 3000,
        horizontalLeadToLeadSpanMax: 3400,
        padWidthMin: 250,
        padWidthMax: 750,
        padHeightMin: 1400,
        padHeightMax: 1800,
        bodyWidthMin: 3000,
        bodyWidthMax: 3400,
        bodyLengthMin: 1400,
        bodyLengthMax: 1800,
        bodyHeightMin: 0,
        bodyHeightMax: 700,
        oddPadWidthMax: 750,
        oddPadWidthMin: 250,
        customPadLength: 1165,
        customPadWidth: 1815,
        customPadToPadGap: 1790,
        customOddPadLength: 1165,
        componentFamily: IpcDataModel.ComponentAttribute.chipComponentFamily["RESISTOR"]
    },

    sod: {
        horizontalPadCount: 2,
        horizontalLeadToLeadSpanMin: 3600,
        horizontalLeadToLeadSpanMax: 3900,
        padWidthMin: 250,
        padWidthMax: 320,
        padHeightMin: 550,
        padHeightMax: 750,
        bodyWidthMin: 2550,
        bodyWidthMax: 2850,
        bodyLengthMin: 1400,
        bodyLengthMax: 1800,
        bodyHeightMin: 0,
        bodyHeightMax: 1350,
        bodyOffsetMin: 150,
        bodyOffsetMax: 150,
        customPadLength: 1158,
        customPadWidth: 839,
        customPadToPadGap: 2300,
    },

    moldedBody: {
        horizontalPadCount: 2,
        horizontalLeadToLeadSpanMin: 7000,
        horizontalLeadToLeadSpanMax: 7600,
        padWidthMin: 1000,
        padWidthMax: 1600,
        padHeightMin: 2300,
        padHeightMax: 2500,
        bodyWidthMin: 7000,
        bodyWidthMax: 7600,
        bodyLengthMin: 4000,
        bodyLengthMax: 4600,
        bodyHeightMin: 0,
        bodyHeightMax: 4300,
        oddPadHeightMax: 2500,
        oddPadHeightMin: 2300,
        oddPadWidthMax: 1600,
        oddPadWidthMin: 1000,
        customPadLength: 2368,
        customPadWidth: 2430,
        customPadToPadGap: 3870,
        customOddPadLength: 2368,
        customOddPadWidth: 2430,
        componentFamily: IpcDataModel.ComponentAttribute.moldedBodyComponentFamily["RESISTOR"]
    },

    sodfl : {
        horizontalPadCount: 2,
        horizontalLeadToLeadSpanMin: 1500,
        horizontalLeadToLeadSpanMax: 1700,
        padWidthMin: 150,
        padWidthMax: 250,
        padHeightMin: 250,
        padHeightMax: 350,
        bodyWidthMin: 1100,
        bodyWidthMax: 1300,
        bodyLengthMin: 700,
        bodyLengthMax: 900,
        bodyHeightMin: 0,
        bodyHeightMax: 700,
        oddPadHeightMax: 350,
        oddPadHeightMin: 250,
        oddPadWidthMax: 250,
        oddPadWidthMin: 150,
        customPadLength: 540,
        customPadWidth: 400,
        customPadToPadGap: 1050,
        customOddPadLength: 540,
        customOddPadWidth: 400
    },

    dfn2: {
        horizontalPadCount: 2,
        padWidthMin: 220,
        padWidthMax: 280,
        padHeightMin: 470,
        padHeightMax: 540,
        horizontalPinPitch: 650,
        bodyWidthMin: 950,
        bodyWidthMax: 1050,
        bodyLengthMin: 550,
        bodyLengthMax: 650,
        bodyHeightMin: 0,
        bodyHeightMax: 300,
        horizontalLeadToLeadSpanMax: 930,
        horizontalLeadToLeadSpanMin: 870,
        componentFamily: IpcDataModel.ComponentAttribute.dfnComponentFamily.DFN_2["DIODE"],
        customPadLength: 600,
        customPadWidth: 350,
        customPadToPadGap: 300
    },

    dfn3: {
        horizontalPadCount: 3,
        padWidthMin: 220,
        padWidthMax: 300,
        padHeightMin: 120,
        padHeightMax: 200,
        verticalPinPitch: 350,
        bodyWidthMin: 950,
        bodyWidthMax: 1050,
        bodyLengthMin: 550,
        bodyLengthMax: 650,
        bodyHeightMin: 0,
        bodyHeightMax: 400,
        horizontalPinPitch: 650,
        oddPadHeightMax: 550,
        oddPadHeightMin: 470,
        oddPadWidthMax: 300,
        oddPadWidthMin: 220,
        horizontalLeadToLeadSpanMax: 950,
        horizontalLeadToLeadSpanMin: 870,
        componentFamily: IpcDataModel.ComponentAttribute.dfnComponentFamily.DFN_34["DIODE"],
        customPadLength: 360,
        customPadWidth: 260,
        customPadToPadGap: 280,
        customOddPadLength: 360,
        customOddPadWidth: 610
    },

    dfn4: {
        horizontalPadCount: 4,
        padWidthMin: 300,
        padWidthMax: 400,
        padHeightMin: 230,
        padHeightMax: 280,
        verticalPinPitch: 450,
        bodyWidthMin: 1150,
        bodyWidthMax: 1250,
        bodyLengthMin: 750,
        bodyLengthMax: 800,
        bodyHeightMin: 0,
        bodyHeightMax: 400,
        horizontalPinPitch: 750,
        horizontalLeadToLeadSpanMax: 1150,
        horizontalLeadToLeadSpanMin: 1050,
        componentFamily: IpcDataModel.ComponentAttribute.dfnComponentFamily.DFN_34["DIODE"],
        customPadLength: 460,
        customPadWidth: 350,
        customPadToPadGap: 280
    },

    ecap: {
        horizontalPadCount: 2,
        horizontalLeadToLeadSpanMin: 10800,
        horizontalLeadToLeadSpanMax: 12200,
        padWidthMin: 3300,
        padWidthMax: 3700,
        padHeightMin: 700,
        padHeightMax: 1100,
        bodyWidthMin: 10100,
        bodyWidthMax: 10500,
        bodyLengthMin: 10100,
        bodyLengthMax: 10500,
        bodyHeightMin: 0,
        bodyHeightMax: 10500,
        terminalGapMax: 4800,
        terminalGapMin: 4200,
        customPadLength: 4420,
        customPadWidth: 2120,
        customPadToPadGap: 4290
    },

    crystal: {
        horizontalPadCount: 2,
        horizontalLeadToLeadSpanMin: 12800,
        horizontalLeadToLeadSpanMax: 13200,
        padWidthMin: 4160,
        padWidthMax: 4160,
        padHeightMin: 500,
        padHeightMax: 790,
        bodyWidthMin: 11300,
        bodyWidthMax: 11700,
        bodyLengthMin: 4800,
        bodyLengthMax: 5000,
        bodyHeightMin: 0,
        bodyHeightMax: 4500,
        terminalGapMax: 4880,
        terminalGapMin: 4480,
        customPadLength: 4730,
        customPadWidth: 1610,
        customPadToPadGap: 4660,
        customPadPitch: 9400
    },

    melf: {
        horizontalPadCount: 2,
        horizontalLeadToLeadSpanMin: 3300,
        horizontalLeadToLeadSpanMax: 3700,
        padWidthMin: 350,
        padWidthMax: 500,
        padHeightMin: 1450,
        padHeightMax: 1600,
        bodyWidthMin: 3300,
        bodyWidthMax: 3700,
        bodyLengthMin: 1450,
        bodyLengthMax: 1600,
        componentFamily: IpcDataModel.ComponentAttribute.melfComponentFamily["RESISTOR"],
        customPadLength: 1150,
        customPadWidth: 1740,
        customPadToPadGap: 2210
    },

    chipArrayTwoSideFlatConcaveData: {
        horizontalPadCount: 8,
        horizontalLeadToLeadSpanMin: 1800,
        horizontalLeadToLeadSpanMax: 2400,
        padWidthMin: 250,
        padWidthMax: 550,
        padHeightMin: 650,
        padHeightMax: 950,
        verticalPinPitch: 1270,
        bodyWidthMin: 1800,
        bodyWidthMax: 2400,
        bodyLengthMin: 4780,
        bodyLengthMax: 5380,
        bodyHeightMin: 0,
        bodyHeightMax: 700,
        componentFamily: IpcDataModel.ComponentAttribute.chipArrayComponentFamily.FLAT_CONCAVE["RESISTOR"],
        customPadLength: 1120,
        customPadWidth: 830,
        customPadToPadGap: 1060
    },

    chipArrayFourSideFlatConcaveData: {
        horizontalPadCount: 10,
        horizontalLeadToLeadSpanMin: 1900,
        horizontalLeadToLeadSpanMax: 2300,
        padWidthMin: 300,
        padWidthMax: 500,
        padHeightMin: 250,
        padHeightMax: 550,
        verticalPinPitch: 800,
        bodyWidthMin: 1900,
        bodyWidthMax: 2300,
        bodyLengthMin: 3800,
        bodyLengthMax: 4200,
        bodyHeightMin: 0,
        bodyHeightMax: 700,
        oddPadHeightMax: 650,
        oddPadHeightMin: 350,
        oddPadWidthMax: 450,
        oddPadWidthMin: 250,
        componentFamily: IpcDataModel.ComponentAttribute.chipArrayComponentFamily.FLAT_CONCAVE["RESISTOR"],
        customPadLength: 1020,
        customPadWidth: 430,
        customOddPadLength: 970,
        customOddPadWidth: 530,
        customPadToPadGap: 1180,
        customPadToPadGap1: 3180
    },

    chipArrayTwoSideConvexData: {
        horizontalPadCount: 10,
        horizontalLeadToLeadSpanMin: 1800,
        horizontalLeadToLeadSpanMax: 2400,
        padWidthMin: 350,
        padWidthMax: 550,
        padHeightMin: 300,
        padHeightMax: 400,
        verticalPinPitch: 640,
        bodyWidthMin: 1800,
        bodyWidthMax: 2400,
        bodyLengthMin: 3200,
        bodyLengthMax: 3400,
        bodyHeightMin: 0,
        bodyHeightMax: 700,
        oddPadHeightMax: 550,
        oddPadHeightMin: 450,
        componentFamily: IpcDataModel.ComponentAttribute.chipArrayComponentFamily.TWO_SIDE_CONVEX["RESISTOR"],
        customPadLength: 1160,
        customPadWidth: 310,
        customPadToPadGap: 1000,
        customOddPadWidth: 460
    },

    oscCornerConcave: {
        horizontalPadCount: 4,
        bodyWidthMin: 6300,
        bodyWidthMax: 6700,
        bodyLengthMin: 3800,
        bodyLengthMax: 4200,
        bodyHeightMin: 0,
        bodyHeightMax: 1200,
        horizontalTerminalGapMin: 2800,
        horizontalTerminalGapMax: 3200,
        verticalTerminalGapMin: 1300,
        verticalTerminalGapMax: 1700,
        customPadLength: 2060,
        customPadWidth: 1560,
        customPadToPadGap: 2780,
        customPadToPadGap1 : 1280
    },

    oscJLead: {
        horizontalPadCount: 4,
        horizontalLeadToLeadSpanMin: 9400,
        horizontalLeadToLeadSpanMax: 9800,
        padHeightMin: 200,
        padHeightMax: 800,
        verticalPinPitch: 5080,
        bodyWidthMin: 8400,
        bodyWidthMax: 8800,
        bodyLengthMin: 13800,
        bodyLengthMax: 14200,
        bodyHeightMin: 0,
        bodyHeightMax: 4700,
        bodyOffsetMin: 1000,
        bodyOffsetMax: 1000,
        terminalCenterToCenterDistance: 7620,
        customPadLength: 2620,
        customPadWidth: 870,
        customPadSpan1: 10520
    },

    oscLBend: {
        horizontalPadCount: 4,
        horizontalLeadToLeadSpanMin: 9400,
        horizontalLeadToLeadSpanMax: 9800,
        padHeightMin: 200,
        padHeightMax: 800,
        verticalPinPitch: 5080,
        bodyWidthMin: 8750,
        bodyWidthMax: 9150,
        bodyLengthMin: 13800,
        bodyLengthMax: 14200,
        bodyHeightMin: 0,
        bodyHeightMax: 4700,
        terminalCenterToCenterDistance: 7620,
        customPadLength: 2620,
        customPadWidth: 770,
        customPadSpan1: 9820
    },

    soj: {
        horizontalPadCount: 20,
        horizontalLeadToLeadSpanMin: 8510,
        horizontalLeadToLeadSpanMax: 8810,
        padHeightMin: 360,
        padHeightMax: 510,
        verticalPinPitch: 1270,
        bodyWidthMin: 7420,
        bodyWidthMax: 7620,
        bodyLengthMin: 12600,
        bodyLengthMax: 13000,
        bodyHeightMin: 0,
        bodyHeightMax: 3750,
        bodyOffsetMin: 1010,
        bodyOffsetMax: 1010,
        terminalCenterToCenterDistance: 6800,
        customPadLength: 2430,
        customPadWidth: 610,
        customPadSpan1: 9530
    },

    bga: {
        horizontalPadCount: 11,
        padWidthMin: 300,
        padWidthMax: 300,
        padHeightMin: 300,
        padHeightMax: 300,
        verticalPinPitch: 500,
        horizontalPinPitch: 500,
        bodyWidthMin: 5800,
        bodyWidthMax: 6200,
        bodyLengthMin: 5800,
        bodyLengthMax: 6200,
        bodyHeightMin: 0,
        bodyHeightMax: 1000,
        verticalPadCount: 11,
        terminalType: IpcDataModel.ComponentAttribute.bgaTerminalType["Collapsing_Ball"],
        customPadDiameter : 250
    },

    plcc: {
        horizontalPadCount: 7,
        verticalPadCount: 7,
        horizontalLeadToLeadSpanMin: 12320,
        horizontalLeadToLeadSpanMax: 12570,
        padWidthMin: 1720,
        padWidthMax: 1970,
        padHeightMin: 330,
        padHeightMax: 530,
        verticalPinPitch: 1270,
        bodyWidthMin: 11420,
        bodyWidthMax: 11580,
        bodyLengthMin: 11420,
        bodyLengthMax: 11580,
        bodyHeightMin: 0,
        bodyHeightMax: 4570,
        bodyOffsetMin: 510,
        bodyOffsetMax: 510,
        verticalLeadToLeadSpanMax: 12570,
        verticalLeadToLeadSpanMin: 12320,
        terminalCenterToCenterDistance: 10600,
        terminalCenterToCenterDistance2: 10600,
        customPadLength: 2380,
        customPadWidth: 620,
        customPadSpan1: 13290,
        customPadSpan2: 13290
    },

    qfp: {
        horizontalPadCount: 16,
        verticalPadCount: 16,
        horizontalLeadToLeadSpanMin: 12700,
        horizontalLeadToLeadSpanMax: 13100,
        verticalLeadToLeadSpanMax: 13100,
        verticalLeadToLeadSpanMin: 12700,
        padWidthMin: 780,
        padWidthMax: 1030,
        padHeightMin: 170,
        padHeightMax: 270,
        thermalPadLength: 7000,
        thermalPadWidth: 7000,
        thermalPadSolderPasteStencilApertureGapX: 530,
        thermalPadSolderPasteStencilApertureGapY: 530,
        thermalPadSolderPasteStencilApertureLength: 2710,
        thermalPadSolderPasteStencilApertureWidth: 2710,
        thermalPadSolderPasteStencilRowCount: 2,
        thermalPadSolderPasteStencilColCount: 2,
        verticalPinPitch: 500,
        bodyWidthMin: 9800,
        bodyWidthMax: 10200,
        bodyLengthMin: 9800,
        bodyLengthMax: 10200,
        bodyHeightMin: 0,
        bodyHeightMax: 1200,
        bodyOffsetMin: 50,
        bodyOffsetMax: 50,
        customPadLength: 1850,
        customPadWidth: 280,
        customPadSpan1: 13820,
        customPadSpan2: 13820
    },

    qfn: {
        horizontalPadCount: 6,
        verticalPadCount: 8,
        horizontalLeadToLeadSpanMin: 4900,
        horizontalLeadToLeadSpanMax: 5100,
        verticalLeadToLeadSpanMax: 4100,
        verticalLeadToLeadSpanMin: 3900,
        padWidthMin: 300,
        padWidthMax: 500,
        padHeightMin: 200,
        padHeightMax: 300,
        thermalPadLength: 3000,
        thermalPadWidth: 2000,
        thermalPadSolderPasteStencilApertureGapX: 230,
        thermalPadSolderPasteStencilApertureGapY: 150,
        thermalPadSolderPasteStencilApertureLength: 1160,
        thermalPadSolderPasteStencilApertureWidth: 770,
        thermalPadSolderPasteStencilRowCount: 2,
        thermalPadSolderPasteStencilColCount: 2,
        verticalPinPitch: 500,
        bodyWidthMin: 4900,
        bodyWidthMax: 5100,
        bodyLengthMin: 3900,
        bodyLengthMax: 4100,
        bodyHeightMin: 0,
        bodyHeightMax: 1000,
        customPadLength: 860,
        customPadWidth: 270,
        customPadSpan2: 5730,
        customPadSpan1: 4730
    },

    cfp: {
        horizontalPadCount: 16,
        horizontalLeadToLeadSpanMin: 11000,
        horizontalLeadToLeadSpanMax: 11600,
        padWidthMin: 900,
        padWidthMax: 1270,
        padHeightMin: 380,
        padHeightMax: 480,
        verticalPinPitch: 1270,
        bodyWidthMin: 6580,
        bodyWidthMax: 7620,
        bodyLengthMin: 10870,
        bodyLengthMax: 11170,
        bodyHeightMin: 0,
        bodyHeightMax: 2000,
        bodyOffsetMin: 250,
        bodyOffsetMax: 250
    },

    cqfp: {
        horizontalPadCount: 13,
        verticalPadCount: 13,
        horizontalLeadToLeadSpanMin: 22230,
        horizontalLeadToLeadSpanMax: 22470,
        verticalLeadToLeadSpanMax: 22470,
        verticalLeadToLeadSpanMin: 22230,
        padWidthMin: 1020,
        padWidthMax: 1270,
        padHeightMin: 200,
        padHeightMax: 330,
        verticalPinPitch: 1270,
        bodyWidthMin: 16780,
        bodyWidthMax: 17780,
        bodyLengthMin: 16780,
        bodyLengthMax: 17780,
        bodyHeightMin: 0,
        bodyHeightMax: 4920,
        bodyOffsetMin: 510,
        bodyOffsetMax: 510
    },

    son: {
        horizontalPadCount: 14,
        padWidthMin: 300,
        padWidthMax: 500,
        padHeightMin: 200,
        padHeightMax: 300,
        verticalPinPitch: 500,
        bodyWidthMin: 2900,
        bodyWidthMax: 3100,
        bodyLengthMin: 3900,
        bodyLengthMax: 4100,
        bodyHeightMin: 0,
        bodyHeightMax: 800,
        thermalPadLength: 1500,
        thermalPadWidth: 3400,
        thermalPadSolderPasteStencilApertureGapX: 0,
        thermalPadSolderPasteStencilApertureGapY: 260,
        thermalPadSolderPasteStencilApertureLength: 1320,
        thermalPadSolderPasteStencilApertureWidth: 1160,
        thermalPadSolderPasteStencilRowCount: 2,
        thermalPadSolderPasteStencilColCount: 1,
        customPadLength: 860,
        customPadWidth: 270,
        customPadSpan1: 3730
    },

    axial: {
        horizontalPadCount: 2,
        terminalWidth: 630,
        terminalLength: 630,
        bodyWidthMax: 8500,
        bodyWidthMin: 8500,
        bodyLengthMax: 2500,
        bodyLengthMin: 2500,
        bodyHeightMax: 2500,
        bodyHeightMin: 0,
        padToHoleRatio: 1.5,
        verticalPinPitch: 11760
    },

    dip: {
        horizontalPadCount: 16,
        leadSpan: 7620,
        terminalThickness: 120,
        terminalWidth: 530,
        terminalLength: 2400,
        verticalPinPitch: 2540,
        bodyWidthMax: 6600,
        bodyWidthMin: 6600,
        bodyLengthMax: 19690,
        bodyLengthMin: 19690,
        bodyHeightMax: 5080,
        bodyHeightMin: 0,
        bodyOffset: 381,
        padToHoleRatio: 1.5
    },

    headerStraightData: {
        horizontalPadCount: 4,
        verticalPadCount: 2,
        verticalPinPitch: 2540,
        horizontalPinPitch: 2540,
        terminalWidth: 640,
        terminalLength: 640,
        bodyWidthMax: 5080,
        bodyWidthMin: 5080,
        bodyLengthMax: 10160,
        bodyLengthMin: 10160,
        bodyHeightMax: 2540,
        bodyHeightMin: 0,
        terminalTailLength: 3000,
        terminalPostLength: 5840,
        pinNumberSequencePattern: IpcDataModel.PthComponentAttribute.type.HEADER.pinNumberSequencePattern["LRCW"].key,
        padToHoleRatio: 1.5
    },

    headerRightAngleData: {
        horizontalPadCount: 4,
        verticalPadCount: 2,
        verticalPinPitch: 2540,
        horizontalPinPitch: 2540,
        terminalWidth: 640,
        terminalLength: 640,
        bodyWidthMax: 2540,
        bodyWidthMin: 2540,
        bodyLengthMax: 10160,
        bodyLengthMin: 10160,
        bodyHeightMax: 5560,
        bodyHeightMin: 0,
        horizontalTerminalTailLength: 1520,
        verticalTerminalTailLength: 3000,
        terminalPostLength: 5840,
        pinNumberSequencePattern: IpcDataModel.PthComponentAttribute.type.HEADER.pinNumberSequencePattern["LRCW"].key,
        padToHoleRatio: 1.5
    },

    headerStraightSocketData: {
        horizontalPadCount: 4,
        verticalPadCount: 2,
        verticalPinPitch: 2540,
        horizontalPinPitch: 2540,
        terminalWidth: 640,
        terminalLength: 640,
        bodyWidthMax: 5080,
        bodyWidthMin: 5080,
        bodyLengthMax: 10160,
        bodyLengthMin: 10160,
        bodyHeightMax: 2540,
        bodyHeightMin: 0,
        terminalTailLength: 3000,
        pinNumberSequencePattern: IpcDataModel.PthComponentAttribute.type.HEADER.pinNumberSequencePattern["LRCW"].key,
        padToHoleRatio: 1.5
    },

    headerRightAngleSocketData: {
        horizontalPadCount: 4,
        verticalPadCount: 2,
        verticalPinPitch: 2540,
        horizontalPinPitch: 2540,
        terminalWidth: 640,
        terminalLength: 640,
        bodyWidthMax: 7360,
        bodyWidthMin: 7360,
        bodyLengthMax: 10160,
        bodyLengthMin: 10160,
        bodyHeightMax: 5560,
        bodyHeightMin: 0,
        horizontalTerminalTailLength: 1520,
        verticalTerminalTailLength: 3000,
        pinNumberSequencePattern: IpcDataModel.PthComponentAttribute.type.HEADER.pinNumberSequencePattern["LRCW"].key,
        padToHoleRatio: 1.5
    },

    radialRoundData: {
        horizontalPadCount: 2,
        verticalPinPitch: 5080,
        terminalWidth: 650,
        terminalLength: 650,
        bodyWidthMax: 10000,
        bodyWidthMin: 10000,
        bodyLengthMax: 10000,
        bodyLengthMin: 10000,
        bodyHeightMax: 11000,
        bodyHeightMin: 0,
        padToHoleRatio: 1.5
    },

    radialLedRoundData: {
        horizontalPadCount: 2,
        verticalPinPitch: 2540,
        terminalThickness:500,
        terminalWidth: 600,
        terminalLength: 600,
        bodyWidthMax: 5650,
        bodyWidthMin: 5650,
        bodyLengthMax: 5650,
        bodyLengthMin: 5650,
        bodyHeightMax: 8600,
        bodyHeightMin: 0,
        bodyOffset: 0,
        padToHoleRatio: 1.5
    },

    crystalHC49Data: {
        horizontalPadCount: 2,
        verticalPinPitch: 4880,
        terminalWidth: 600,
        terminalLength: 600,
        bodyWidthMax: 11200,
        bodyWidthMin: 10600,
        bodyLengthMax: 4850,
        bodyLengthMin: 4450,
        bodyHeightMax: 3500,
        bodyHeightMin: 0,
        padToHoleRatio: 1.5
    },

    femaleStandoffSpacerData: {
        horizontalPadCount: 1,
        plated: false,
        withPad: false,
        viaThermalRelief: false,
        withVia: false,
        viaDiameter: 0,
        viaCount: 0,
        viaCenterOffset: 0,
        padDiameter: 5250,
        holeDiameter: 3500,
        hasThread: true,
        threadDepth: 8000,
        bodyWidthMax: 6350,
        bodyWidthMin: 6350,
        bodyHeightMax: 25400,
        bodyHeightMin: 0
    },

    maleFemaleStandoffSpacerData: {
        horizontalPadCount: 1,
        plated: false,
        withPad: false,
        viaThermalRelief: false,
        withVia: false,
        viaDiameter: 0,
        viaCount: 0,
        viaCenterOffset: 0,
        padDiameter: 5250,
        holeDiameter: 3500,
        postLength: 6350,
        innerThreadDepth: 6350,
        bodyWidthMax: 6350,
        bodyWidthMin: 6350,
        bodyHeightMax: 19050,
        bodyHeightMin: 0
    },

    SnapLockData: {
        horizontalPadCount: 2,
        bodyHeightMin: 0,
        bodyHeightMax: 8128,
        lockHeightMin: 2000,
        lockHeightMax: 2000,
        bodyWidthMin: 4600,
        bodyWidthMax: 4600,
        lockWidth: 3800,
        holeDiameter : 3200,
        boardThickness: 1600
    },

    ChipLedData: {
        horizontalPadCount: 2,
        horizontalLeadToLeadSpanMin: 1400,
        horizontalLeadToLeadSpanMax: 1600,
        padWidthMin: 250,
        padWidthMax: 300,
        padHeightMin: 700,
        padHeightMax: 800,
        bodyWidthMin: 1400,
        bodyWidthMax: 1600,
        bodyLengthMin: 700,
        bodyLengthMax: 800,
        bodyHeightMin: 0,
        bodyHeightMax: 800,
        baseHeightMin : 0,
        baseHeightMax : 250,
        domeDiameter : 700,
        customPadLength: 610,
        customPadWidth: 850,
        customPadToPadGap: 820
    },
};
